import { render } from "./ServicesList.vue?vue&type=template&id=71f05b36"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"

import "./ServicesList.vue?vue&type=style&index=0&id=71f05b36&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__